export class CreateSopRequestDto {
    /**
     * Unique identifier from ZenQMS
     * @example 'ZEN-5432'
     */
    zenqmsId?: string;

    /**
     * SOP Number
     * @example 'ACME-QA-SOP-042'
     */
    sopNumber: string;

    /**
     * Title of the SOP
     * @example 'Product Complaint'
     */
    sopTitle?: string;

    /**
     * Revision of the SOP
     * @example 'Managed by MAH / 4.0'
     */
    sopRevision?: string;

    /**
     * Date of current revision (ISO 8601 format)
     * @example '2025-02-15'
     */
    revisionDate?: string;

    /**
     * Date when next review is required (ISO 8601 format)
     * @example '2026-02-15'
     */
    nextReviewDate?: string;

    /**
     * URL to document in ZenQMS
     * @example 'https://qnc.zenqms.com/docs/ACME-QA-SOP-042'
     */
    documentUrl?: string;

    /**
     * Who manages this SOP
     * @example 'MAH / 3PL QA'
     */
    managedBy?: string;

    /**
     * Area/Process SOP applies to
     * @example 'ClientComplaint, PV, 3PL_Receiving'
     */
    context?: string;

    /**
     * Whether this SOP is a Q&C SOP
     * @example true
     */
    qncSop?: boolean;

    /**
     * When this record was last synced from ZenQMS (ISO 8601 format)
     * @example '2025-04-05T14:30:22.000Z'
     */
    lastSyncedAt?: string;

    /**
     * Status of synchronization
     * @example 'Success'
     */
    syncStatus?: string;

    /**
     * Foreign key to Warehouse Details
     */
    warehouseDetailId?: string;
}
